import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet, Platform } from "react-native";

import moment from "moment";
import { capitalize } from "lodash";

import AppTheme from "../../AppTheme";
import ReportHours from "./ReportHours";
import ReportItem from "./ReportItem";
import { navigate } from "../../../../helpers/utils";
import ShowMoreItems from "../../common/ShowMoreItems";

const FORMATS = {
  day: "ddd, MMMM DD",
  week: "MMM DD",
  month: "MMMM",
  quarter: "MMMM",
  year: "YYYY",
};

export default function TeamReportItem({ report, editReport, type, isCardReport, controller }) {
  const [hours, setHours] = useState(0);
  const [mood, setMood] = useState(0);
  const [reportDate, setReportDate] = useState("");
  const [headerText, setHeaderText] = useState("");
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [reportsList, setReportsList] = useState([]);
  const [message, setMessage] = useState("");
  const initialNumToRender = 3;

  useEffect(() => {
    const timeUnit = report.timeUnit;
    const reports = report.reports || [];

    setMood(report.mood);
    setHours(report.minutes != null ? Math.round(report.minutes / 60) : null);
    setHeaderText(reports?.length + " Reports");

    let date = moment(report.reference_day);
    if (timeUnit == "week") date.add(6, "days");
    setReportDate(
      capitalize(timeUnit) + " ending " + date.format(FORMATS[timeUnit]),
    );

    if (reports.length > initialNumToRender) {
      setHasMoreItems(true);
      setReportsList(reports.slice(0, initialNumToRender));
      const left = reports.length - initialNumToRender;
      setMessage(left + " more " + (left == 1 ? "report" : "reports"));
    } else {
      setHasMoreItems(false);
      setReportsList(reports);
    }
  }, []);

  const showMore = () => {
    setReportsList(report.reports);
    setHasMoreItems(false);
    setMessage("");
  };

  const viewAggReports = () => {
    const { users, id_aggregated_report } = report;

    if (!id_aggregated_report) return;

    const entity = "report:" + id_aggregated_report;
    const params = { reportId: id_aggregated_report };
    controller.getApiData(entity, params, (data) => {
      navigate(controller, "rn:view_report", "changepage", {
        report: {
          ...data,
          users,
        },
      });
    });
  };

  return (
    <View
      style={[
        styles.container,
        isCardReport ? styles.cardReportItem : styles.shadow,
      ]}
    >
      <View style={[styles.reportHeader]}>
        <View style={[styles.left]}>
          <ReportHours mood={mood} hours={hours} onPress={viewAggReports} />
        </View>

        <View style={styles.right}>
          {/* User name */}
          <Text
            style={[styles.reportLink]}
            numberOfLines={1}
            onPress={() => viewAggReports(report.id_aggregated_report)}
          >
            {headerText}
          </Text>

          {/* Date */}
          <View style={styles.row}>
            <Text style={styles.thin}>{reportDate}</Text>
          </View>
        </View>
      </View>

      {reportsList.map((item) => (
        <ReportItem
          key={item.id + "_team"}
          report={item}
          type={type}
          isTeamReport={true}
          editReport={editReport}
          controller={controller}
        />
      ))}

      <ShowMoreItems
        onPress={showMore}
        message={message}
        hasMoreItems={hasMoreItems}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    backgroundColor: "#FFF",
    marginBottom: 8,
  },
  shadow: {
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 3,
    elevation: 5,
    borderRadius: 4,
  },
  cardReportItem: {
    marginLeft: -10,
  },
  reportHeader: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    backgroundColor: "#FFF",
    height: 45,
    paddingRight: 24,
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
  },
  flex: {
    display: "flex",
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  left: {
    display: "flex",
    alignItems: "center",
    marginHorizontal: 8,
    paddingVertical: 8,
  },
  right: {
    display: "flex",
    flex: 1,
  },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: 28,
    marginBottom: 4,
  },
  thin: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    marginBottom: 3,
  },
  reportLink: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    textDecorationLine: "underline",
  },
});
